import api from "./apiClient";


const getAllCases = () => {
    return api.get(`/cases`);
}

const getHbpCases = () => {
    return api.get(`/hbp-cases`);
}

const getDIACases = () => {
    return api.get(`/dia-cases`);
}

const getDocCaseandPatientData = (doctorId: any) => {
    return api.get(`/doctor-stats/${doctorId}`);
}


export {
    getHbpCases,
    getAllCases,
    getDIACases,
    getDocCaseandPatientData
}
